import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { StrategyAdvancedSettingsComponent } from "@m19-board/shared/strategy-advanced-settings/strategy-advanced-settings.component";
import { StrategyPageService } from "@m19-board/strategies/strategy-page/strategy-page.service";

@Component({
  selector: "app-strategy-page-advanced-settings",
  imports: [TranslocoDirective, StrategyAdvancedSettingsComponent],
  templateUrl: "./strategy-page-advanced-settings.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategyPageAdvancedSettingsComponent {
  private readonly strategyPageService = inject(StrategyPageService);

  readonly strategy = this.strategyPageService.strategy;
  readonly advancedSettings = this.strategyPageService.advancedSettings;
  readonly strategyGroup = this.strategyPageService.strategyGroup;
}

export type AdvancedSettings =
  | "strategyLabel"
  | "targetMinDailySpend"
  | "autoCampaign"
  | "productTargeting"
  | "aiPoweredTargeting"
  | "disableProductTargeting"
  | "dayparting"
  | "tosro"
  | "strategyGroup"
  | "boostAudience"
  | "frequencyCap"
  | "boostAmazonBusiness"
  | "agencyFee"
  | "boostPlacementTop"
  | "onlyB2B";
